import { render } from "./ClinicsMision.vue?vue&type=template&id=1c3d0f7b"
import script from "./ClinicsMision.vue?vue&type=script&lang=js"
export * from "./ClinicsMision.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__